import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/Button';
import { PreviousIcon } from 'pages/path-finding-page/config/Icons';
import { prev } from 'pages/path-finding-page/states/pathFindingSlice';
import { selectSettingParams } from 'pages/path-finding-page/states/selectors';

function ButtonPrev() {
  const dispatch = useDispatch();
  const settingParams = useSelector(selectSettingParams);

  const handleOnClick = () => {
    dispatch(prev());
  };

  return <Button bgColor='bg-gray-100' icon={<PreviousIcon color='action' />} title='Previous' onClick={handleOnClick} disabled={settingParams.disabled} />;
}

export default ButtonPrev;
